import {useDispatch, useSelector} from "react-redux";

import {CheckboxButton} from "@pg-design/checkbox-module";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {useOfferListMapRailTransportElements} from "../../hooks/use_offer_list_map_rail_transport_elements";
import {Layer, setMapLayers} from "../../map/state/map_layers_slice";
import {hitListingMapCheckbox} from "../../tracking/listing_map_events";

export const MapLayerButtons = (props: {transportRoutes: IOSMPoisRoutesGrouped[] | null}) => {
    const dispatch = useDispatch();
    const {transportLines} = useSelector((state: IRPStore) => state.offerListMap.layers);
    const mapElements = useOfferListMapRailTransportElements({shouldFetch: transportLines, routes: props.transportRoutes});

    const isMapElementsLoading = mapElements.requestState === RequestState.Waiting;

    return (
        <>
            <CheckboxButton
                name="price"
                checked={transportLines}
                onChange={() => {
                    dispatch(setMapLayers({[Layer.TransportLines]: !transportLines}));
                    hitListingMapCheckbox(!transportLines);
                }}
                labelContent="Komunikacja szynowa"
                isLoading={isMapElementsLoading}
                size="lg"
            />
            {/* <CheckboxButton
                name="price"
                checked={price}
                onChange={() => {
                    dispatch(setMapLayers({[Layer.Price]: !price}))
                }}
                labelContent="Ceny"
                size="lg"
                isLoading={isMapElementsLoading}
            /> */}
        </>
    );
};
import {useDispatch, useSelector} from "react-redux";

import {CheckboxButton} from "@pg-design/checkbox-module";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {useOfferListMapRailTransportElements} from "../../hooks/use_offer_list_map_rail_transport_elements";
import {Layer, setMapLayers} from "../../map/state/map_layers_slice";
import {hitListingMapCheckbox} from "../../tracking/listing_map_events";

export const MapLayerButtons = (props: {transportRoutes: IOSMPoisRoutesGrouped[] | null}) => {
    const dispatch = useDispatch();
    const {transportLines} = useSelector((state: IRPStore) => state.offerListMap.layers);
    const mapElements = useOfferListMapRailTransportElements({shouldFetch: transportLines, routes: props.transportRoutes});

    const isMapElementsLoading = mapElements.requestState === RequestState.Waiting;

    return (
        <>
            <CheckboxButton
                name="price"
                checked={transportLines}
                onChange={() => {
                    dispatch(setMapLayers({[Layer.TransportLines]: !transportLines}));
                    hitListingMapCheckbox(!transportLines);
                }}
                labelContent="Komunikacja szynowa"
                isLoading={isMapElementsLoading}
                size="lg"
            />
            {/* <CheckboxButton
                name="price"
                checked={price}
                onChange={() => {
                    dispatch(setMapLayers({[Layer.Price]: !price}))
                }}
                labelContent="Ceny"
                size="lg"
                isLoading={isMapElementsLoading}
            /> */}
        </>
    );
};
